<template>
  <div class="bgFrame">
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
    </div>
    <div
      class="box"
      style="z-index: 501; display: flex; justify-content: center"
    >
      <div class="textFrame">
        <div style="width: 100%; margin-top: 152px;"></div>
        <div :class="animeClass">
          <div style="display: flex; justify-content: center">
            <div class="textSubFrame" v-if="realData">{{realData.title}}</div>
          </div>
           <div style='margin-top:-130px;text-align: center;font-size: 102px;font-family: DINCondensed-Bold, DINCondensed;font-weight: bold;color: rgba(128, 113, 101, 0.1);'>Precisely Control Calories</div>
          <div style="width: 100%; margin-top: 10px;"></div>
          <div style="display: flex; justify-content: center">
            <div class="textContent" v-if="realData" v-html="realData.describes"></div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 34px;"></div>
        <div
          style="
            width: 100%;
            padding-top: 56%;
            margin-top: -120px;
            position: relative;
          "
        >
          <div class="btn" style="left: 0px;justify-content: flex-end;" id="btnleft" @click="controlLeft">
            <img
              src="../../assets/btn_arrow_l.png"
              style="width: 36px;margin-right:15px;"
            />
          </div>
          <swiper
            :allowTouchMove="false"
            :loop="true"
            :slidesPerView="1"
            :centeredSlides="true"
            :spaceBetween="10"
            @afterInit="initswiper"
            :pagination="{
              type: 'fraction',
            }"
            :navigation="false"
            :modules="modules"
            id="scrollSwiper"
          >
            <swiper-slide class="swiperSlider" v-for="(item, index) in goodsList" :key="index">
              <food
                v-for="(items,indexs) in item" :key="indexs"
                :start="startFood"
                :data="items"
                style="width: 33%; height: 50%;position: relative;"
              ></food>
            </swiper-slide>
          </swiper>
          <div class="btn" id="btnright" style="right:0px;justify-content: flex-start;" @click="controlRight">
            <img
              src="../../assets/btn_arrow_r.png"
              style="width: 36px;margin-left:15px;"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import Food from "./food.vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

export default {
  name: "App",
  components: {
    Food,
    Swiper,
    SwiperSlide,
  },
  props: {
    design: Object,
  },
  setup(props) {
    const realData = ref({
      title: '',
      describes: '',
      nuMatchDetailsList: []
    })
    watch(
        () => props.design,
            (newProps) => {
                realData.value = newProps
                let arr = [];
                let list = [];
                for (let i = 0; i < realData.value.nuMatchDetailsList.length; i++) {
              let temp = realData.value.nuMatchDetailsList[i];
              let index = arr.indexOf(temp.groupingId);
              if (index > -1) {
                let goods = (temp.goodsList.length > 0) ? temp.goodsList[0] : ''
                goods.index = parseInt(temp.type) - 1
                goods.img = temp.url
                if (goods.index == 0) {
                  goods.detail = [{ type: "4", value: goods.protein },{ type: "1", value: goods.carbonWater },{ type: "3", value: goods.fat }]
                } else {
                  goods.detail = [{ type: "4", value: goods.protein },{ type: "1", value: goods.carbonWater },{ type: "2", value: goods.dietaryFiber }]
                }
                list[index].splice(goods.index, 1, goods)
              } else {
                arr.push(temp.groupingId)
                index = list.length
                list.push([{},{},{}])
                let goods = (temp.goodsList.length > 0) ? temp.goodsList[0] : ''
                goods.index = parseInt(temp.type) - 1
                goods.img = temp.url
                if (goods.index == 0) {
                  goods.detail = [{ type: "4", value: goods.protein },{ type: "1", value: goods.carbonWater },{ type: "3", value: goods.fat }]
                } else {
                  goods.detail = [{ type: "4", value: goods.protein },{ type: "1", value: goods.carbonWater },{ type: "2", value: goods.dietaryFiber }]
                }
                list[index].splice(goods.index, 1, goods)
              }
            }
              goodsList.value = list
              console.log('=======',goodsList.value)
            }
        );
    onMounted(() => {});
    const swiperRef = ref(null);
    // const goodsList = ref([
    //   [{ index: 0, name: "鳳梨咕嚕蝦", img: require('../../assets/min1.png'), price: "20", quantityHeat: '118', detail :[{ type: "4", value: "11.9g" },{ type: "1", value: "8.7g" },{ type: "3", value: "3.9g" }] },
    //   { index: 1, name: "手撕包菜", img: require('../../assets/min6.png'),price: "30", quantityHeat: '84' ,detail :[{ type: "4", value: "1.9g" },{ type: "1", value: "9.1g" },{ type: "2", value: "2g" }]},
    //   { index: 2, name: "蒸山藥", img: require('../../assets/min9.png'),price: "10", quantityHeat: '90' ,detail :[{ type: "4", value: "2.9g" },{ type: "1", value: "19.3g" },{ type: "2", value: "1.1g" }]}],
    //   [{ index: 0, name: "日式蒲燒鰻魚", img: require('../../assets/min4.png'),price: "40", quantityHeat: '192', detail :[{ type: "4", value: "12.6g" },{ type: "1", value: "6.8g" },{ type: "3", value: "12.7g" }]},
    //    { index: 1, name: "西芹百合", img: require('../../assets/min7.png'),price: "20", quantityHeat: '40' ,detail :[{ type: "4", value: "1.1g" },{ type: "1", value: "6.9g" },{ type: "2", value: "2.6g" }]},
    //    { index: 2, name: "三色藜麥飯", img: require('../../assets/min5.png'),price: "40", quantityHeat: '173' ,detail :[{ type: "4", value: "4g" },{ type: "1", value: "38.6g" },{ type: "2", value: "0.9g" }]}],
    //   [{ index: 0, name: "黑椒牛仔粒", img: require('../../assets/min2.png'),price: "40", quantityHeat: '170', detail :[{ type: "4", value: "17.3g" },{ type: "1", value: "6g" },{ type: "3", value: "8.5g" }] },
    //   { index: 1, name: "紅燒冬瓜", img: require('../../assets/min3.png'),price: "10", quantityHeat: '23' ,detail :[{ type: "4", value: "1g" },{ type: "1", value: "4.4g" },{ type: "2", value: "1.7g" }]},
    //    { index: 2, name: "蒸紅薯", img: require('../../assets/min8.png'),price: "30", quantityHeat: '107' ,detail :[{ type: "4", value: "3g" },{ type: "1", value: "23g" },{ type: "2", value: "2.9g" }]},
    //    ]
    // ]);
    const goodsList = ref([]);
    const initswiper = (swiper) => {
      swiperRef.value = swiper
    };
    const controlLeft = () => {
      swiperRef.value.slidePrev(300, true);
    };
    const controlRight = () => {
      swiperRef.value.slideNext(300, true);
    };
    const startAnime = ref(false);
    const startFood = ref(false);
    const animeClass = ref('start_anime')

    const changeAnime = () => {
      startFood.value = false;
      animeClass.value = 'start_anime'
      let btn1 = document.getElementById('btnright')
      btn1.style.opacity = '0'
      let btn = document.getElementById('btnleft')
      btn.style.opacity = '0'
      setTimeout(() => {
        if (startAnime.value == false) {
        startFood.value = true;
        setTimeout(() => {
            animeClass.value = 'anime'
        }, 700);
        setTimeout(() => {
            let btn1 = document.getElementById('btnright')
            btn1.style.opacity = '1'
            let btn = document.getElementById('btnleft')
            btn.style.opacity = '1'
        }, 1200);
      }
      }, 800);
    };
    let pointImg = ref(require('../../assets/noise.png'))
    return {
      realData,
      pointImg,
      animeClass,
      startFood,
      changeAnime,
      startAnime,
      goodsList,
      controlRight,
      controlLeft,
      initswiper,
      swiperRef,
      modules: [Pagination, Navigation],
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes textAnime {
    from  {
      transform: translate(0px, 40px);
      opacity: 0;
      }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.anime{
  z-index : 999;
  opacity: 1;
  animation-name: textAnime;
  animation-duration: 1s;
  position: relative;
}
.start_anime{
  z-index : 999;
  opacity: 0;
  position: relative;
}
.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.box {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.textFrame {
  height: 100%;
  width: 1100px;
  display: flex;
  flex-direction: column;
  align-content: center;
}
.textSubFrame {
  font-size: 67px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
.textImg {
  width: calc(100% / 338 * 312);
  aspect-ratio: 312 / 19;
}
.textContent {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 29px;
}
.largeImg {
  width: 100%;
  aspect-ratio: 594 / 312;
  display: flex;
  justify-content: left;
}
.swiper {
  position: absolute;
  width: 80%;
  height: 100%;
  left: 10%;
  right: 10%;
  top: 0px;
}
:deep(.swiper-slide) {
  width: 100%;
  height: 100%;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn{
    position: absolute;
    top: 0px;
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    opacity: 0;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1s steps(2) infinite;
}

</style>
